/**
 * FERP Portal - Schedule List Page (DRR-074: Tabulator DRY Template)
 *
 * OPTIMIZE Phase: Cron-based triggers for recurring workflow execution.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function ScheduleListPage() {
  return <TabulatorPrimitiveManager primitiveType="schedule" />;
}

export default ScheduleListPage;
